import type { LucideIcon } from 'lucide-react';
import { Heart, Megaphone, BookOpen, Award, Wrench, Calendar, HelpCircle, Users, Building2, Layers } from 'lucide-react';

export interface MediaCategory {
  id: string;
  label: string;
  icon: LucideIcon;
  color: string;
}

export interface MediaItem {
  id: string;
  titulo: string;
  descricao?: string | null;
  categoria: string;
  arquivoUrl: string;
  tipoArquivo?: string;
  criadoEm: string;
  atualizadoEm?: string;
  escolaId?: string;
  municipioId?: string;
  ativo?: boolean;
}

export interface MediaUploadPayload {
  titulo: string;
  descricao?: string;
  categoria: string;
  arquivoUrl: string;
  tipoArquivo?: string;
}

export interface MediaConfig {
  /** Perfil que consome o módulo */
  scope: 'ESCOLA' | 'MUNICIPAL' | 'ESTADUAL' | 'REDE' | 'MASTER';

  /** Identificador do tenant ativo (escolaId, municipioId, etc.) */
  scopeId: string;

  /** Títulos e labels da página */
  labels: {
    heroTitle: string;
    heroSubtitle: string;
    searchPlaceholder?: string;
    emptyTitle?: string;
    emptySubtitle?: string;
    stepNumber?: number;
    totalSteps?: number;
  };

  /** Categorias disponíveis para filtragem e categorização */
  categories: MediaCategory[];

  /** Features ativadas */
  features: {
    allowCompress: boolean;
    maxFileSizeMb: number;
    showHowItWorksBanner: boolean;
    showSetupHero: boolean;
    canManage?: boolean;
  };

  /** Ação de disparo ao clicar no botão "Enviar via Comunicado" */
  onSendToComunicado?: (media: MediaItem) => void;
}

/** Categorias padrão do Banco de Mídias Municipal */
export const MUNICIPAL_MEDIA_CATEGORIAS: MediaCategory[] = [
  { id: 'COMEMORATIVO', label: 'Datas Comemorativas', icon: Heart, color: '#ec4899' },
  { id: 'CAMPANHA', label: 'Campanhas', icon: Megaphone, color: '#8b5cf6' },
  { id: 'EDUCACAO', label: 'Educação', icon: BookOpen, color: '#2563eb' },
  { id: 'SAUDE', label: 'Saúde / Vacinação', icon: Award, color: '#10b981' },
  { id: 'OBRA', label: 'Obras / Infra', icon: Wrench, color: '#f59e0b' },
  { id: 'EVENTO', label: 'Eventos', icon: Calendar, color: '#6366f1' },
  { id: 'OUTRO', label: 'Outros', icon: HelpCircle, color: '#6b7280' },
];

/** Categorias padrão do Banco de Mídias Escolar */
export const ESCOLA_MEDIA_CATEGORIAS: MediaCategory[] = [
  { id: 'COMEMORATIVO', label: 'Comemorativo', icon: Heart, color: '#ec4899' },
  { id: 'CAMPANHA', label: 'Campanha', icon: Megaphone, color: '#8b5cf6' },
  { id: 'EVENTO', label: 'Evento Escolar', icon: Calendar, color: '#6366f1' },
  { id: 'REUNIAO', label: 'Reunião de Pais', icon: Users, color: '#2563eb' },
  { id: 'EDUCACAO', label: 'Pedagógico', icon: BookOpen, color: '#059669' },
  { id: 'OUTRO', label: 'Informativo', icon: HelpCircle, color: '#6b7280' },
];
